import React, { useState } from "react";
import PropTypes from "kf-proptypes/widgets";
import { Trans } from "@lingui/macro";
import { Show } from "control-flow-react";

import { Popover } from "../../feedback/index.jsx";
import {
  POPOVER_POSITIONS,
  POPOVER_TRIGGERS
} from "@widgets/feedback/popover/index.jsx";
import { BUTTON_SIZES, BUTTON_TYPES, Button } from "@widgets/inputs/index.jsx";
import {
  ICON_PADDING,
  ICON_SIZE,
  ICON_STROKE,
  KF_ICONS,
  KfIcon
} from "@widgets/common/components/primitives/kf_icon/index.jsx";

import styles from "./styles.css";

export function ResetDialog({
  inheritedFrom = "",
  getPanelContainer,
  onReset
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover
      isOpen={isOpen}
      position={POPOVER_POSITIONS.BOTTOM_LEFT}
      targetRenderer={() => (
        <KfIcon
          icon={KF_ICONS.RESET}
          size={ICON_SIZE.SIZE_12}
          stroke={ICON_STROKE.THIN}
          onClick={() => setIsOpen(true)}
          className={styles.resetIcon}
        />
      )}
      trigger={POPOVER_TRIGGERS.CLICK}
      {...(getPanelContainer && { getContainer: getPanelContainer })}
      themeClassName="no-theme"
    >
      <div className={styles.resetDialog}>
        <div>
          <div className={styles.header}>
            <div className={`tiny-400 ${styles.dialog}`}>
              <Show
                when={inheritedFrom}
                fallBack={<Trans>Reset to default value</Trans>}
              >
                <Trans>Resetting will inherit the value from</Trans>
                {" :"}
              </Show>
            </div>
            <KfIcon
              icon={KF_ICONS.CLOSE}
              size={ICON_SIZE.SIZE_12}
              stroke={ICON_STROKE.THIN}
              onClick={() => setIsOpen(false)}
              padding={ICON_PADDING.PADDING_4}
              className={styles.closeIcon}
            />
          </div>
          <div className={`small ${styles.propertyName}`}>{inheritedFrom}</div>
        </div>
        <div className={styles.footer}>
          <Button
            size={BUTTON_SIZES.SMALL}
            type={BUTTON_TYPES.SECONDARY}
            onClick={() => setIsOpen(false)}
          >
            <Trans>Cancel</Trans>
          </Button>
          <Button
            size={BUTTON_SIZES.SMALL}
            onClick={() => {
              onReset();
              setIsOpen(false);
            }}
          >
            <Trans>Reset</Trans>
          </Button>
        </div>
      </div>
    </Popover>
  );
}

ResetDialog.propTypes = {
  inheritedFrom: PropTypes.string.isRequired,
  getPanelContainer: PropTypes.func,
  onReset: PropTypes.func.isRequired
};
